import { render, staticRenderFns } from "./RecentActivityItem.vue?vue&type=template&id=c00b878a&scoped=true&"
import script from "./RecentActivityItem.vue?vue&type=script&lang=ts&"
export * from "./RecentActivityItem.vue?vue&type=script&lang=ts&"
import style0 from "./RecentActivityItem.vue?vue&type=style&index=0&id=c00b878a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00b878a",
  null
  
)

export default component.exports